import InvestmentDeclarationCard from './investmentDeclarationCard';
export default InvestmentDeclarationCard;